import { z } from 'zod';
import {
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';

export const ZodGraphicWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    image_type: z.nullable(z.string()),
    link: z.string(),
});

export type GraphicWidgetConfigurationDetails = z.infer<
    typeof ZodGraphicWidgetConfigurationDetails
>;

export const ZodGraphicWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.GRAPHIC),
    config: ZodGraphicWidgetConfigurationDetails,
});

export type GraphicWidgetConfiguration = z.infer<typeof ZodGraphicWidgetConfiguration>;
